<template>
  <div class="top-line">
    <div class="logo">
      <!-- Logo image -->
      <router-link to="/">
        <img src="../../assets/sezenaksu.png" alt="sezenaksu logo" />
      </router-link>
    </div>
    <div class="site-tools">
      <div class="social">
        <!-- facebook -->
        <a
          href="https://www.facebook.com/SezenAksu"
          class="diginity dg-facebook"
          target="_blank"
        >
          <span>facebook</span>
        </a>
        <!-- spotify -->
        <a
          href="https://open.spotify.com/artist/64d1rUxfizSAOE9UbMnUZd"
          class="diginity dg-spotify"
          target="_blank"
        >
          <span>spotify</span>
        </a>
        <!-- dezeer -->
        <a
          href="https://www.deezer.com/en/artist/9289"
          class="diginity dg-dezeer"
          target="_blank"
        >
          <span>dezeer</span>
        </a>
        <!-- itunes -->
        <a
          href="https://itunes.apple.com/us/artist/sezen-aksu/id14420857"
          class="diginity dg-itunes"
          target="_blank"
        >
          <span>itunes</span>
        </a>
      </div>
      <!-- subscribe email -->
      <div class="input">
        <div class="language">
          <router-link v-if="lng !== 'tr'" tag="a" to="/tr">TR</router-link>
          <router-link v-else tag="a" to="/en">EN</router-link>
        </div>
      </div>
      <!-- switch language -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      subscribeEmail: "",
    };
  },
  computed: {
    ...mapGetters(["t", "lng"]),
  },
  methods: {
    async subscribe() {
      // email validate
      const emailValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      // email validation mismatch
      if (!emailValid.test(this.subscribeEmail)) {
        return alert(this.t.contact.errorEmail);
      }

      // 'store/Actions.js' see => 'subscribe'
      const subscribe = await this.$store.dispatch(
        "subscribe",
        this.subscribeEmail
      );
      if (subscribe) {
        this.subscribeEmail = "";
        return alert(this.t.contact.sendSuccess);
      } else {
        return alert(this.t.contact.sendError);
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../styles/colors";
$width: 600px;
/* topline */
.top-line {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /* logo */
  .logo {
    text-align: center;
    @media screen and (max-width: $width) {
      width: 100%;
    }
    a {
      height: 100%;
      img {
        height: 100%;
      }
    }
  }
  /* sitet tools */
  .site-tools {
    padding: 3px 0;
    width: 300px;
    @media screen and (max-width: $width) {
      padding-top: 25px;
      width: 100%;
    }
    .social {
      text-align: center;
      width: 100%;
      margin-bottom: 5px;
      a {
        margin: 0 3px;
        font-size: 22px;
        position: relative;
        display: inline-block;
        span {
          display: none;
          position: absolute;
          bottom: 100%;
          right: 0;
          font-size: 11px;
          background: rgba(33, 33, 33, 0.8);
          border-radius: 2px;
          color: #fff;
          padding: 3px;
          margin-bottom: 5px;
          font-family: sans-serif;
          &:after {
            content: "";
            border: 3px solid transparent;
            border-top-color: rgba(33, 33, 33, 0.8);
            top: 100%;
            right: 8px;
            position: absolute;
          }
        }
        &:hover span {
          display: block;
        }
      }
    }
    .input {
      margin-top: 20px;
      position: relative;
      input {
        padding-right: 45px;
        &:focus {
          border: 1px solid $main;
        }
      }
      span.subscribe-button {
        background: $main;
        color: #fff;
        padding: 6px;
        height: 100%;
        cursor: pointer;
        font-size: 23px;
        line-height: 28px;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 5;
        &:hover {
          background: $mainLight;
        }
      }
    }
    .language {
      cursor: default;
      text-align: right;
      padding: 5px 0 0;
      text-align: center;
      a {
        color: #008cba;
        cursor: pointer;
        &:hover {
          color: #0078a0;
        }
      }
    }
  }
}
</style>
